<template>
    <base-spinner :open="isloading"></base-spinner>
    <div class="site__body">
        <div class="block-space block-space--layout--spaceship-ledge-height"></div>
        <div class="block faq">
            <div class="container container--max--xl">
                <div class="flexbox-page-info-container">
                    <div class="flex-item-page-info-breadcrumbs">
                        <nav class="breadcrumb block-header__breadcrumb" aria-label="breadcrumb">
                            <ol class="breadcrumb__list">
                                <li class="breadcrumb__spaceship-safe-area" role="presentation"></li>
                                <li class="breadcrumb__item breadcrumb__item--parent breadcrumb__item--first">
                                    <router-link to="/" class="breadcrumb__item-link">Home</router-link>
                                </li>
                                <li class="breadcrumb__item breadcrumb__item--parent">
                                    <router-link to="/search-results" class="breadcrumb__item-link">Search Results</router-link>
                                </li>						                                						                               
                                <li class="breadcrumb__item breadcrumb__item--parent">
                                    <router-link to="" class="breadcrumb__item-link">Interchange</router-link>
                                </li>						                                						                               
                                <li class="breadcrumb__title-safe-area" role="presentation"></li>
                            </ol>
                        </nav>
                    </div>
                    <div class="flex-item-page-info-title">
                        <h1 class="block-header__breadcrumb-slim">Catalog Interchange</h1>
                    </div>                      
                </div>
                <div class="document__content card">
                    <div class="document__content">
                        <div class="flexbox-container--vehicle-selection-form flexbox-container--vehicle-selection-form-vertical-adj">	
                            <div>
                                <div class="card-header-catalog">
                                    <h5 class="card-header-catalog">Parts Interchange Search for {{ searcheditem }}</h5>
                                </div>
                                <div class="card-divider"></div>
                                <div class="block-space block-space--layout--divider-order-entry"></div>
                                <div class="container">                                                     
                                    <div class="flex-container--drilldown-2">  
                                        <div class="vehicle-form vehicle-form--layout--account">								 
                                            <div class="row">
                                                <div class="span5">
                                                    <div class="flex-container--drilldown-select-vehicle-inputs">
                                                        <input type="text" class="form-control form-control-order-entry " placeholder="Item" aria-label="Interchange Part Number" v-model="searchitem">
                                                    </div>
                                                </div>
                                                <div class="span5">
                                                    <div class="flex-container--drilldown-parts-interchange-button">
                                                        <button type="button" class="btn btn-md btn-primary" @click.prevent="getManufacturers">Search</button> 
                                                        <!-- <a href="/order-parts" class="btn btn-md btn-grey">New Lookup</a> -->
                                                    </div>	   
                                                </div>
                                
                                            </div>	      
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>                        							
                    </div>
                    <div class="document__content">
                        <div class="flexbox-container--vehicle-selection-form flexbox-container--vehicle-selection-form-vertical-adj">	
                            <div>
                                <div class="card-header-catalog">
                                    <h5 class="card-header-catalog">Manufacturers for {{ searcheditem }} (Select Below to View Products)</h5>
                                </div>
                                <div class="card-divider"></div>
                                <div class="block-space block-space--layout--divider-order-entry"></div>
                                <div class="container">                                                     
                                    <div v-if="manufacturers.length === 0">
                                        <p class="text-center mt-3">
                                            No manufacturers found.
                                        </p>
                                    </div>
                                    <div v-else>  
                                        <label class="input-check-form-container" v-for="manufacturer in manufacturers" :key="manufacturer.manufacturer">{{ manufacturer.description }}
                                            <input type="checkbox" v-model="selectedManufacturers" :value="manufacturer.manufacturer" />
                                            <span class="checkmark"></span>
                                        </label>
                                        <div class="mt-3">
                                            <!-- <router-link :to="'/interchange-search/' + searchitem" class="btn btn-md btn-primary mr-2">Find Substitutes</router-link> -->
                                            <button type="button" class="btn btn-md btn-primary mr-2" @click.prevent="findSubstitutes">Find Substitutes</button>
                                            <button type="button" class="btn btn-md btn-grey mr-2" @click.prevent="selectAll">Select All</button>
                                            <button type="button" class="btn btn-md btn-grey" @click.prevent="unselectAll">Unselect All</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>                        							
                    </div>
                </div>    
            </div>
        </div>
        <div class="block-space block-space--layout--before-footer"></div>
    </div>
</template>

<script>
import axiosvl from "../../../axios/axios-vl.js";

export default {
    props: {
        sku: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            searchitem: '',
            searcheditem: '',
            selectedManufacturers: [],
            manufacturers : [],
            isloading: false,
            servermessages: []
        };
    },
    methods: {
        getManufacturers() {
            this.manufacturers = [], this.selectedManufacturers = [];
            this.isloading = true;

            this.searcheditem = this.searchitem;
            const catpn = this.$store.getters['storeConfigID'];
            axiosvl.post(this.$store.getters['api/interchange_manufacturers_uri'], {
                "webroutine": {
                    "context": {
                        "session-key-method": "hidden"
                    },
                    "fields": {
                        "EHCUST": {"value": this.$store.getters.customer},
                        "CATPN": {"value": catpn},
                        "NEWITEM": {"value": this.searchitem }
                    }
                }
            }).then((response) => {
                const fields = response.data.webroutine.fields
                let messages = [];

                if (fields.RESULTCOD.value === 'OK') {
                    for (const key in response.data.webroutine.lists.CMFRSD.entries) {
                        const obj = response.data.webroutine.lists.CMFRSD.entries[key];
                        this.manufacturers.push({
                            manufacturer: obj.QCMFRC,
                            description: obj.QCMFR,
                        });
                    }
                } else {
                    const wrmessages = response.data.webroutine.messages;

                    for (var i = 0; i < wrmessages.length; i++) {
                        messages.push(wrmessages[i]);
                    }

                    // Return code is not "OK" but no messages appear, add a custom error message
                    if (messages.length === 0) {
                        messages.push("Something went wrong. Please try again later.");
                    }
                }

                this.isloading = false;
                this.servermessages = messages;
            }).catch((error) => {
            this.isloading = false;
                console.log("error - " + error);
            });
        },
        selectAll() {
            this.selectedManufacturers = [];
            for (const key in this.manufacturers) {
                const code = this.manufacturers[key].manufacturer;
                this.selectedManufacturers.push(code);
            }
        },
        unselectAll() {
            this.selectedManufacturers = [];
        },
        findSubstitutes() {
            let interchangedata = [];

            for (let x in this.selectedManufacturers) {
                let mnf = this.manufacturers.find((selected) => {
                    return selected.manufacturer === this.selectedManufacturers[x];
                });
                interchangedata.push(mnf);
            }

            this.$store.dispatch("product/setInterchangeSku", this.searchitem);
            this.$store.dispatch("product/setInterchangeManufacturers", interchangedata);

            this.$router.push('/interchange-search');
        }
    },
    created() {
        this.$ga.page({
            page: this.$route.fullPath,
            title: this.$route.name,
        });
        this.searchitem = this.sku;
        this.getManufacturers();
    }
}
</script>
